<template>
  <v-expand-x-transition duration="25">
    <v-card
      tile
      dark
      style="z-index: 1; overflow-x:hidden;"
      width="300"
      :height="height"
      :max-height="height"
      elevation="6"
      class="tab overflow-y-auto"
    >
      <slot />
    </v-card>
  </v-expand-x-transition>
</template>

<script>
export default {
  name: 'BaseTab',

  data: () => ({
    windowHeight: window.innerHeight
  }),

  computed: {
    height: function () {
      return this.windowHeight - 60
    }
  },

  created () {
    window.addEventListener('resize', () => {
      this.windowHeight = window.innerHeight
    })
  },

  mounted () {
    this.windowHeight = window.innerHeight
  },

  destroyed () {
    window.removeEventListener('resize', () => {
      this.windowHeight = window.innerHeight
    })
  }
}
</script>
